<template>
  <div class="container">
    <div class="group">
      <h1 class="page-title has-text-centered">
        RESET PASSWORD
      </h1>
      <template v-if="!message">
        <p class="lead">Enter the e-mail associated with your account</p>
        <form @submit.prevent="recoverPassword">
          <div class="field email-address">
            <label class="label">E-mail Address</label>
            <div class="control">
              <input v-model="email" class="input" type="email" />
            </div>
          </div>
          <div class="field">
            <button class="button is-fullwidth" type="submit">
              Continue
            </button>
          </div>
          <div class="field">
            <router-link
              class="button is-fullwidth is-secondary is-outlined"
              to="/"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </template>
      <div v-else class="has-text-centered">
        <p class="lead">Check Your Email to Reset Your Password</p>
        <p>{{ message }}</p>
        <p>
          If you don’t receive the link, please check your spam folder or
          <a href="mailto:mail@someone.us" class="has-text-primary">
            contact us
          </a>
          .
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      message: ''
    };
  },
  methods: {
    recoverPassword() {
      if (this.email != '') {
        this.axiosRequest('post', `Auth/ForgotPassword`, {
          email: this.email,
          subject: 'Reset your password',
          linkUrl: process.env.VUE_APP_URL + '/reset-password'
        })
          .then(response => {
            this.message = response.data.message;
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      } else {
        this.showErrorMessage('Please enter a valid email');
      }
    }
  }
};
</script>

<style lang="scss">
.page-forgot-password {
  .email-address {
    margin: 4.75rem 0 6.25rem;
  }
}
</style>
